const nav = {
  // The logo is a button; this is what it does. That makes the image itself
  // decorative (alt=""), or a screen reader would announce it twice.
  logoToHome: 'Back to your overview',
  logoToTeam: 'Back to your team overview',
  myTeam: 'My team',
  home: 'Home',
  intro: 'A quick explanation',
  quiz: 'Test yourself',
  // Web: the test lives in the app; this label points to the store screen.
  app: 'The app',
  teamEnvironment: 'Team space',
  results: 'Result',
  library: 'Personas',
  history: 'History',
  conversation: 'My conversation',
  admin: 'Admin',
  logout: 'Log out',
  logoutWithEmail: (email) => `Log out (${email})`,
  menu: 'Menu',
  close: 'Close',
  languageLabel: 'Language',
  switchToEnglish: 'Switch to English',
  switchToDutch: 'Switch to Dutch',
};

export default nav;
